jQuery(document).ready(function() {

    jQuery('.count').counterUp({
      delay: 10,
      time: 2000
    });
    jQuery('.count').addClass('animated fadeInDownBig');
    jQuery('h2').addClass('animated fadeIn');
  });
